import { forwardRef, type TextareaHTMLAttributes } from "react";
import { cn } from "@/lib/utils";
import { claseCampo } from "./input";

export type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement>;

/**
 * Misma piel que `Input` (`claseCampo`), con alto minimo de 80px y redimension
 * solo vertical: la horizontal rompe la grilla del formulario.
 */
export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => (
    <textarea
      ref={ref}
      className={cn(claseCampo, "min-h-20 resize-y py-2", className)}
      {...props}
    />
  ),
);
Textarea.displayName = "Textarea";
